module.exports = __webpack_public_path__ + "img/sr47_samurai01_shop.0ab3e2d5.png";